import { useCallback } from 'react';

import type { GameLaunchProps } from '@sunflower-games/analytics-events/src/games';
import { useNavigate } from 'react-router-dom';

import { GAME_LAUNCH_TRIGGER } from '../config/constants';
import type { CoinType } from '../stores/cointype/CoinTypeStore';
import { useStores } from '../stores/useStores';

export const useStartGame = () => {
  const navigate = useNavigate();
  const { coinTypeStore, gamesSearchStore } = useStores();

  const { coinType: currentCoinType } = coinTypeStore;

  const handleStartGame = useCallback(
    (gameId: number, triggered_by: GameLaunchProps['triggered_by'], coinType?: CoinType) => {
      if (coinType && coinType !== currentCoinType) {
        coinTypeStore.setCoinType(coinType);
      }

      if (gamesSearchStore.searchTerm) {
        gamesSearchStore.cleanSearch();
      }

      localStorage.setItem(GAME_LAUNCH_TRIGGER, triggered_by);
      navigate('/games/' + gameId);
    },
    [navigate, gamesSearchStore, currentCoinType, coinTypeStore],
  );

  return {
    handleStartGame,
  };
};
